module.exports = __webpack_public_path__ + "static/media/select-arrows.2f453396.svg";